module.exports = __webpack_public_path__ + "static/ION4-033bf98d6153b39ac8bece33586b917d.jpg";